export class TaskData {
  public id: string
  public subject: string;
  public activityType = new TaskIdName();
  public activityIcon: string;
  public status: TaskIdName;
  public companyId: string;
  public customer: TaskCustomer;
  public customerName?: string;
  public caseId: string;
  public offerId: string;
  public propertyId: string;
  public propertyLeaseId: string;
  public dueDate: string;
  public dueTime: string;
  public dueDateTime: string;
  public description: string;
  public durationInMinutes: number;
  public assignedToStakeholder = new TaskIdName();
  public partnerCompanyId: string;
  public mandatory: boolean;
  public createdBy: TaskIdName;
  public modifiedBy: TaskIdName;
  public createdAt: string;
  public lastModified: string;
  public recurring: number;
  public recurrance: string;
  public note: string;
  public dvAccountPlanId: string;
  public dvCategoryId: string;
  public priorityId: string;
  public priority = new TaskIdName();
  public property: TaskIdName;
  public propertyLease: TaskIdName;
  public templateId?:string;
  public files?: any;
}

export class NewTask {
  public subject: string = '';
  public activityType: string | null = null;
  public activityName: string;
  public activityIcon: string;
  public status: string = '7cb83847-96ee-4567-8555-b9d770ff16c0';
  public customerId: string | null = null;
  public customerName: string;
  public caseId: string | null = null;
  public offerId: string | null = null;
  public propertyId:string | null = null;
  public propertyLeaseId: string | null = null;
  public dueDate: string;
  public dueTime: string;
  public dueDateTime: string = new Date().toString();
  public templateId: string;
  public priorityId: string | null = null;
  public description: string = '';
  public durationInMinutes: number;
  public assignedToStakeholder: string | null = null;
  public partnerCompanyId: string | null;
  public mandatory: boolean;
  public recurring: number | null = null;
  public recurrance: string = null;
  public note: string = '';
  public dvAccountPlanId: string = null;
  public dvCategoryId: string = null;
}

export class ItemExtra {
  type: string = '';
  name: string = '';
  address: string = '';
  number: string = '';
  image: string | null = null;
  responsible: string = '';
}

export class TaskIdName {
  id: string;
  name: string;
  number?: string;
}

export class TaskCustomer {
  customerId: string;
  name: string;
}

export class TaskType {
  id: string;
  name: string;
  icon: string = "fas fa-question";
  sort: number = 0;
}

export class TaskInput {
  customerId?: string;
  caseId?: string;
  offerId?: string;
  propertyId?: string;
  propertyLeaseId?: string;
  lol: string = 'lol'
}

export class TaskFunctions {
  static splitDateTime(isoString:string){
    const [date, time] = isoString.split('T');
    const [hour, minute] = time.slice(0, 5).split(':');
    const roundedMinute = time.slice(0,5) != '23:59' ? (Math.round(+minute / 15) * 15).toString().padStart(2, '0') : minute;
    if (roundedMinute === '60') {
      const adjustedHour = parseInt(hour, 10) + 1;
      const adjustedMinute = '00';
      return {date: date, time:`${adjustedHour}:${adjustedMinute.padStart(2, '0')}`};
    } 
    else return {date:date, time:`${hour}:${roundedMinute}`};
  }
}